import styled from 'styled-components';

export const StyledBracketedContainer = styled.div`
  position: relative;
  border: solid ${({ theme }) => theme.frameWidth}${" "}${({
      $enabled,
      theme,
  }) => ($enabled ? theme.frame : theme.backgroundDark)};
  background-color: ${({theme, $fillBackground}) => $fillBackground ? theme.background : 'transparent'};

  .container-content {
    height: 100%;
  }
  .corner {
    width: ${({ theme }) => theme.cornerSize};
    height: ${({ theme }) => theme.cornerSize};
    border: solid ${({ theme }) => theme.frameWidth} white;
    position: absolute;
    display: ${({ $enabled }) => ($enabled ? "block" : "none")};
  }

  .corner-tl {
    border-right: none;
    border-bottom: none;
    margin-top: ${({ theme }) => "-" + theme.frameWidth};
    margin-left: ${({ theme }) => "-" + theme.frameWidth};
    top: 0;
    left: 0;
  }

  .corner-tr {
    border-left: none;
    border-bottom: none;
    margin-top: ${({ theme }) => "-" + theme.frameWidth};
    margin-right: ${({ theme }) => "-" + theme.frameWidth};
    top: 0;
    right: 0;
  }

  .corner-br {
    border-left: none;
    border-top: none;
    margin-bottom: ${({ theme }) => "-" + theme.frameWidth};
    margin-right: ${({ theme }) => "-" + theme.frameWidth};
    bottom: 0;
    right: 0;
  }

  .corner-bl {
    border-right: none;
    border-top: none;
    margin-bottom: ${({ theme }) => "-" + theme.frameWidth};
    margin-left: ${({ theme }) => "-" + theme.frameWidth};
    bottom: 0;
    left: 0;
  }
`;
